"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticPanel = exports.StatisticPanelValue = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const React = __importStar(require("react"));
const purple_50_opacity_svg_1 = __importDefault(require("./92b3b47/assets/purple-50-opacity.svg"));
const shapes_green_opacity_svg_1 = __importDefault(require("./92b3b47/assets/shapes-green-opacity.svg"));
const InfoPanel_1 = require("./InfoPanel");
const StatContentWrapper = styled_1.default.div `
	box-sizing: border-box;
	border-radius: ${merlin_theme_1.default.layout.spacing.smaller};
	width: 100%;
	background-image: url(${({ colour }) => colourLookup[colour].image});
	background-repeat: no-repeat;
	background-position: calc(100% + 4rem) ${({ colour }) => `${colourLookup[colour].verticalOffset}px`};
	background-size: auto 12rem;
	font-family: ${merlin_theme_1.default.typography.fonts.base};
	padding: ${merlin_theme_1.default.layout.spacing.standard};

	.stat-panel__label {
		font-size: 1rem;
		font-weight: 500;
		color: ${merlin_theme_1.default.colours.neutral.darkest};
	}
`;
const SubtextWrapper = styled_1.default.div `
	font-size: .75rem;
	color: ${merlin_theme_1.default.colours.text.darkest};
	padding-top: ${merlin_theme_1.default.layout.spacing.smallest};
	font-weight: 500;
`;
const colourLookup = {
    green: {
        colour: merlin_theme_1.default.palette.green.tint,
        image: shapes_green_opacity_svg_1.default,
        verticalOffset: 0,
    },
    purple: {
        colour: merlin_theme_1.default.palette.purple.tint,
        image: purple_50_opacity_svg_1.default,
        verticalOffset: 2,
    },
};
exports.StatisticPanelValue = styled_1.default.div `
	font-size: 3.75rem;
	font-weight: ${merlin_theme_1.default.typography.number.fontWeight};
	color: ${merlin_theme_1.default.colours.neutral.darkest};
	display: inline;
`;
const StatisticPanel = (props) => {
    const { label, value, colour, widthOverride, subtext } = props;
    return (React.createElement(InfoPanel_1.InfoPanel, { colour: colourLookup[colour].colour, widthOverride: widthOverride },
        React.createElement(StatContentWrapper, { "data-testid": `stats-panel-${label}`, colour: colour },
            React.createElement("div", null,
                React.createElement("div", { className: "stat-panel__label" }, label),
                React.createElement(exports.StatisticPanelValue, null, value)),
            React.createElement(SubtextWrapper, null, subtext))));
};
exports.StatisticPanel = StatisticPanel;
//# sourceMappingURL=StatisticPanel.js.map